"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _panelContext = _interopRequireDefault(require("./panel-context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable import/no-unresolved, no-unused-vars, import/extensions */
var Panel = function Panel(_ref) {
  var children = _ref.children,
      background = _ref.background,
      itemId = _ref.itemId;

  var _useContext = (0, _react.useContext)(_panelContext["default"]),
      activePanel = _useContext.activePanel,
      panelClick = _useContext.panelClick;

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: itemId,
    "data-testid": "panel",
    className: "panel".concat(activePanel === itemId ? ' open open-active' : ''),
    style: {
      backgroundImage: "url(\"".concat(background, "\")")
    },
    onClick: function onClick() {
      return panelClick(itemId);
    },
    onKeyDown: function onKeyDown() {
      return panelClick(itemId);
    },
    role: "button",
    tabIndex: 0
  }, children);
};

Panel.defaultProps = {
  background: ''
};
Panel.propTypes = {
  children: _propTypes["default"].node.isRequired,
  itemId: _propTypes["default"].string.isRequired,
  background: _propTypes["default"].string
};
var _default = Panel;
exports["default"] = _default;